import { Link } from "react-router-dom";
import "./project.css";

const getImagePath = (imageName) => `${process.env.PUBLIC_URL}/${imageName}`;

const projectsData = [
  {
    id: 1,
    title: "Secure Website",
    description: "A secure web application with Google authentication, DOS protection, and SQL injection prevention using MongoDB.",
    details:
      "project talk about adding tools security google authentication , and dos and sql injaction with know using mongodb.",
    tech: ["React","Node.js","Tailwind CSS","Mongodb"],
    images: [getImagePath("login.jpeg"), getImagePath("register.jpeg"), getImagePath("order1.jpeg"), getImagePath("dashboard.jpeg")],
  },
  {
    id: 2,
    title: "Restaurant Management System",
    description: "Order, menu and services web application.",
    details:
      "Dashboard system for managing orders, menus, services and customer requests with responsive design and scalable components.",
    tech: ["React", "Tailwind CSS"],
    images: [getImagePath("home.png"), getImagePath("menu.jpeg"), getImagePath("order.jpeg"), getImagePath("service.jpeg")],
  },
  {
    id: 3,
    title: "Menu Management System",
    description: "Menu and details of meals  web application.",
    details:
      "Project for Our Menu Collection to show details to meals,you will button to show many meals foods ,you can show it on youtube how cook it and Light & Dark Modes as feature  .",
    tech: ["Javascript", "HTML", "CSS", "Bootstrap"],
    images: [getImagePath("Menu Collections.png"), getImagePath("Details.png"), getImagePath("More Details.png"), getImagePath("Darkmode.png")],
},
{
  id: 4,
  title: "Cook & Learn – Full Stack Recipe Platform",
  description: "A full stack recipe platform with user authentication, recipe management, and interactive features.",
  details:
    "Cook & Learn is a full stack recipe platform that allows users to create and discover recipes. It features user authentication, recipe management, and interactive features such as comments and ratings.",
  tech: ["React", "Node.js", "Express", "MongoDB", "Bootstrap"],
  images: [getImagePath("cooklearn1.png"), getImagePath("cooklearn2.png"), getImagePath("cooklearn3.png"), getImagePath("cooklearn4.png"),getImagePath("cooklearn5.png"),getImagePath("cooklearn6.png")],
}
];

const Projects = () => {

  return (
    <section id="projects" className="projects">
      <div className="projects-container">
        <h2>Projects</h2>

        <div className="projects-grid">
          {projectsData.map((project) => (
            <div className="project-card" key={project.id}>
              <img
                src={project.images[0]}
                alt={project.title}
                className="project-img"
              />

              <div className="project-body">
                <h4>{project.title}</h4>
                <p>{project.description}</p>

                <div className="tech-list">
                  {project.tech.map((t, i) => (
                    <span key={i}>{t}</span>
                  ))}
                </div>

                {/* ✅ View Details Button */}
                <Link 
                  to={`/projects/${project.id}`}
                  className="details-btn"
                  style={{ textDecoration: "none", display: "inline-block" }}
                >
                  View Details
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal تم حذفه - التفاصيل أصبحت في صفحة منفصلة */}
    </section>
  );
};

export default Projects;